import styled from "styled-components"

// 모달의 input태그들을 감싸는 wrapper
const ModalInputContainer = styled.div`
    display: flex;
    margin-bottom: 0.3rem;
`
export default ModalInputContainer